//Moving Beings
import { TILES } from "./tiles";

export const VERSION = "2023.04.18-04";
export const SPRITE_SHEET_SRC = "./ciabattas-revenge-sprites.png";

export const CELL_SIZE = 16;
export const Z_INDEX_LAYER_SIZE = 10;

// Basics
export const PLACEMENT_TYPE_HERO_SPAWN = "HERO_SPAWN";
export const PLACEMENT_TYPE_GOAL = "PLACEMENT_TYPE_GOAL";
export const PLACEMENT_TYPE_HERO = "HERO";

// Scenes
export const SCENE_TITLE = "SCENE_TITLE";
export const SCENE_HOW_TO_PLAY = "SCENE_HOW_TO_PLAY";
export const SCENE_BEGINNING_STORY = "SCENE_BEGINNING_STORY";
export const SCENE_ENDING_STORY = "SCENE_ENDING_STORY";
export const SCENE_GAME = "SCENE_GAME";

// Enemies
export const PLACEMENT_TYPE_ENEMY_SPAWN = "ENEMY_SPAWN";
export const PLACEMENT_TYPE_ENEMY = "ENEMY";
export const PLACEMENT_TYPE_ROAMING_ENEMY = "ROAMING_ENEMY";
export const PLACEMENT_TYPE_DEAD_CLOWN = "DEAD_CLOWN";
export const PLACEMENT_TYPE_FLYING_ENEMY = "FLYING_ENEMY";
export const PLACEMENT_TYPE_CIABATTA = "CIABATTA";
export const PLACEMENT_TYPE_CIABATTA_BLAST = "CIABATTA_BLAST";

// Bullet
export const PLACEMENT_TYPE_BULLET_PICKUP = "BULLET_PICKUP";
export const PLACEMENT_TYPE_BULLET = "BULLET";

// Warning
export const PLACEMENT_TYPE_WARNING = "WARNING";

//Plcaement
export const PLACEMENT_TYPE_PARTICLE = "PARTICLE";

// Walls
export const PLACEMENT_TYPE_WALL = "WALL";
export const PLACEMENT_TYPE_LOCK = "LOCK";

// Tiles
export const PLACEMENT_TYPE_ICE = "ICE";
export const PLACEMENT_TYPE_FIRE = "FIRE";
export const PLACEMENT_TYPE_WATER = "WATER";
export const PLACEMENT_TYPE_CONVEYOR = "CONVEYOR";
export const PLACEMENT_TYPE_TELEPORT = "TELEPORT";
export const PLACEMENT_TYPE_THIEF = "THIEF";
export const PLACEMENT_TYPE_BULLET_DROPBOX = "BULLET_DROPBOX";

// Blockers and Switches
export const PLACEMENT_TYPE_SWITCH_WALL = "SWITCH_WALL";
export const PLACEMENT_TYPE_SWITCH = "SWITCH";

// Pickups
export const PLACEMENT_TYPE_CHIP = "CHIP";
export const PLACEMENT_TYPE_KEY = "KEY";
export const PLACEMENT_TYPE_ICEBOOTS_PICKUP = "ICE_BOOTS";
export const PLACEMENT_TYPE_FIREBOOTS_PICKUP = "FIRE_BOOTS";
export const PLACEMENT_TYPE_WATER_PICKUP = "WATER_PICKUP";
export const PLACEMENT_TYPE_CLOWN_DEFENSE_PICKUP = "CLOWN_DEFENSE_PICKUP";

export const DIRECTION_LEFT = "LEFT";
export const DIRECTION_RIGHT = "RIGHT";
export const DIRECTION_UP = "UP";
export const DIRECTION_DOWN = "DOWN";
export const directionUpdateMap = {
  [DIRECTION_LEFT]: { x: -1, y: 0 },
  [DIRECTION_RIGHT]: { x: 1, y: 0 },
  [DIRECTION_UP]: { x: 0, y: -1 },
  [DIRECTION_DOWN]: { x: 0, y: 1 },
};

export const BODY_SKINS = {
  NORMAL: "NORMAL",
  WATER: "WATER",
  ICE: "ICE",
  CONVEYOR: "CONVEYOR",
  FIRE: "FIRE",
  TELEPORT: "TELEPORT",
  SCARED: "SCARED",
};

export const LEVEL_THEMES = {
  YELLOW: "YELLOW",
  BLUE: "BLUE",
  GREEN: "GREEN",
  PINK: "PINK",
  GRAY: "GRAY",
};

export const THEME_BACKGROUNDS = {
  [LEVEL_THEMES.YELLOW]: "#2f2808",
  [LEVEL_THEMES.BLUE]: "#3d4c67",
  [LEVEL_THEMES.GREEN]: "#2f2808",
  [LEVEL_THEMES.PINK]: "#673d5e",
  [LEVEL_THEMES.GRAY]: "#96a1c7",
};

export const THEME_TILES_MAP = {
  [LEVEL_THEMES.YELLOW]: {
    FLOOR: "1x1",
    TOP: "1x0",
    LEFT: "0x1",
    RIGHT: "2x1",
    BOTTOM: "1x2",
    WALL: "0x2",
  },
  [LEVEL_THEMES.BLUE]: {
    FLOOR: "4x1",
    TOP: "4x0",
    LEFT: "3x1",
    RIGHT: "5x1",
    BOTTOM: "4x2",
    WALL: "3x2",
  },
  [LEVEL_THEMES.GREEN]: {
    FLOOR: "7x1",
    TOP: "7x0",
    LEFT: "6x1",
    RIGHT: "8x1",
    BOTTOM: "7x2",
    WALL: "6x2",
  },
  [LEVEL_THEMES.PINK]: {
    FLOOR: "10x1",
    TOP: "10x0",
    LEFT: "9x1",
    RIGHT: "11x1",
    BOTTOM: "10x2",
    WALL: "9x2",
  },
  [LEVEL_THEMES.GRAY]: {
    FLOOR: "13x1",
    TOP: "13x0",
    LEFT: "12x1",
    RIGHT: "14x1",
    BOTTOM: "13x2",
    WALL: "12x2",
  },
};

export const KEY_TILES_MAP = {
  BLUE: {
    LOCK: TILES.BLUE_LOCK,
    KEY: TILES.BLUE_KEY,
  },
  GREEN: {
    LOCK: TILES.GREEN_LOCK,
    KEY: TILES.GREEN_KEY,
  },
};

export const LOCK_AND_KEY_COLORS = {
  BLUE: "BLUE",
  GREEN: "GREEN",
};

export const ICE_CORNERS = {
  TOP_LEFT: "TOP_LEFT",
  TOP_RIGHT: "TOP_RIGHT",
  BOTTOM_LEFT: "BOTTOM_LEFT",
  BOTTOM_RIGHT: "BOTTOM_RIGHT",
};

export const INVENTORY = {
  FIRE_PICKUP: "fireBoots",
  ICE_PICKUP: "iceBoots",
  WATER_PICKUP: "waterPickup",
  BLUE_KEY_PICKUP: "blueKey",
  GREEN_KEY_PICKUP: "greenKey",
  FLOUR_PICKUP: "flour",
  BULLET_PICKUP: "bullet",
  CLOWN_DEFENSE: "clownDefense",
};

export const OTHER_DEATH_TYPES = {
  CLOCK: "CLOCK",
};

export const LAYERS = {
  TILES: "TILES",
  PICKUPS: "PICKUPS",
};

export const MODE_PLAY = "PLAY";
export const MODE_EDIT = "EDIT";

//Audio
export const DEFAULT_MUSIC_VOLUME = 0.4;
export const DEFAULT_SFX_VOLUME = 1;

export const LOCAL_STORAGE_INITIAL_LEVEL = "CR_INITIAL_LEVEL";
export const LOCAL_STORAGE_COMPLETED_LEVELS = "CR_COMPLETED_LEVELS";
export const LOCAL_STORAGE_MUSIC_VOLUME = "CR_MUSIC_VOLUME";
export const LOCAL_STORAGE_SFX_VOLUME = "CR_SFX_VOLUME";
export const LOCAL_STORAGE_CUSTOM_LEVELS = "CR_CUSTOM_LEVELS";
export const LOCAL_STORAGE_PLACEMENT_ID = "CR_PLACEMENT_ID";
export const LOCAL_STORAGE_SCENE_MODE = "CR_SCENE_MODE";
